import {Component, OnInit, ViewContainerRef, Pipe, PipeTransform} from '@angular/core';
import {formatDate} from '@angular/common';
import {AppConfig} from '../../config/app.config';
import {HttpParams} from '@angular/common/http';
import {RequestsService} from '../../services/requests.service';
import {ToastsManager} from 'ng6-toastr';
import {SharedService} from '../../services/SharedService';
import {ActivatedRoute, Router} from '@angular/router';
import {  HostListener } from '@angular/core';



@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: []
})
export class NavComponent implements OnInit {

  profile: string;
  first_name: string;
  last_name: string;
  time_clock: string;
  user_id: number;
  sifttime: string;
  status: boolean = true;
modalOpen = false;
  time_clock_check: boolean = true;
  user:any;
  store_name:any;
  store_data:any;
    path:any;
  constructor(public toastr: ToastsManager, vcr: ViewContainerRef,private requestsService: RequestsService,private router: Router,public sharedService: SharedService, public activeRoute: ActivatedRoute) {
    this.toastr.setRootViewContainerRef(vcr);
    if (!window.localStorage.getItem(btoa('access_token')) || window.localStorage.getItem(btoa('access_token'))=='null' || window.localStorage.getItem(btoa('access_token'))==null) {
      this.router.navigate(['./login']);
    }
      console.log (window.localStorage.getItem("screen_locked"));
    
    if (window.localStorage.getItem("screen_locked")=="1"){

            this.router.navigate(['./locking']);
    }
  }
dropdownOpen = false;

notifications = [];
notifications_all = [];
@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  const target = event.target as HTMLElement;
  const clickedInside = target.closest('#notificationWrapper');

  if (!clickedInside) {
    this.dropdownOpen = false;
  }
}

toggleDropdown() {
  this.dropdownOpen = !this.dropdownOpen;
}
openModal(event: MouseEvent) {
  event.preventDefault();
  event.stopPropagation(); // prevent dropdown from closing the modal instantly
  this.modalOpen = true;
  this.dropdownOpen = false;
}

closeModal() {
  this.modalOpen = false;
}

  ngOnInit() {
      this.path = this.activeRoute.routeConfig.path;
    // User Info
    this.time_clock_check = this.requestsService.CheckMenuPermission(39);
    
    /// Get Time
    if (window.localStorage.getItem(btoa('clocktime'))) {

      setInterval(() => {
        this.sifttime = this.requestsService.getClockTime();
      }, 1000);
      this.status = false;
    }

    this.sharedService.accountSetting().subscribe(x => {
      this.user = JSON.parse(atob(window.localStorage.getItem(btoa('user'))));
      this.setUserInfo();
    });

    this.user = JSON.parse(atob(window.localStorage.getItem(btoa('user'))));
    this.store_data = JSON.parse(atob(window.localStorage.getItem(btoa('store_data'))));
    this.setUserInfo();
    this.get_recent_notifications();
    this.get_recent_notifications_all();
  }
  
  get_recent_notifications (){
      let body = new HttpParams();
    
      this.requestsService.postRequest('api/get_recent_notifications', body)
        .subscribe(
          (response: any[]) => {
           this.notifications = response;
          }
        );
  }
  get_recent_notifications_all (){
      let body = new HttpParams();
    
      this.requestsService.postRequest('api/get_recent_notifications_all', body)
        .subscribe(
          (response: any[]) => {
           this.notifications_all = response;
          }
        );
  }
  setUserInfo() {
    this.first_name = this.user.user_first_name;
    this.last_name = this.user.user_last_name;
    this.store_name = this.store_data.store_name;
    this.user_id = this.user.user_id;
    this.profile = AppConfig.NT_HTTP_PROTOCOL + AppConfig.NT_HTTP_SEPARATOR + AppConfig.NT_PROFILE_PATH + this.user.user_picture;
  }
  lock_screen(){
    window.localStorage.setItem("screen_locked","1");
    this.router.navigate(['/locking'], { queryParams: { t: new Date().getTime() } });
  }
  timeClock() {
    let body = new HttpParams();
    body = body.set('user_id', this.user.user_id);

    return this.requestsService.clockTime(body).subscribe((response: Response) => {
      // console.log('time check',response);
      if (response['result_type'] === 'Success') {
        if (response['clocktime_in'] == 'time_in') {

          window.localStorage.setItem(btoa('clocktime'), btoa(response['clocktime']));
          window.localStorage.setItem(btoa('time_zone'), btoa(response['time_zone']));
          setInterval(() => {
            this.sifttime = this.requestsService.getClockTime();
          }, 1000);
          this.status = false;
          this.toastr.success(response['message'], response['result_type']);
        } else {
          window.localStorage.removeItem(btoa('clocktime'));
          window.localStorage.removeItem(btoa('time_zone'));
          this.status = true;
          this.toastr.success('Checked out successfully', response['result_type']);
        }

        // this.toastr.success(response['message'], response['result_type']);
      } else {
        this.toastr.error(response['message'], response['result_type']);
      }
    });


  }
}
